import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './src/css/tailwind.css';
require('typeface-titillium-web');
require('typeface-lobster');
